// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { createFromProduct } from "@insite/client-framework/Common/ProductInfo";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import loadProduct from "@insite/client-framework/Store/Data/Products/Handlers/LoadProduct";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import addToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import translate from "@insite/client-framework/Translate";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps } from "@insite/mobius/Icon";
import { ImgProps } from "@insite/mobius/Img";
import { LinkPresentationProps } from "@insite/mobius/Link/Link";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import { StyledImgWrapper } from "@store/MobiusOverrides/Img/Img";
import { linkAltStyles } from "@store/Themes/common/mixins/link";
import openMinicartDrawer from "@store/Framework/Store/Store/Components/MinicartDrawer/Handlers/openMinicartDrawer";
import closePartFinderDrawer from "@store/Framework/Store/Store/Components/PartFinder/Handlers/ClosePartFinderDrawer";
import openPartFinderDrawer from "@store/Framework/Store/Store/Components/PartFinder/Handlers/OpenPartFinderDrawer";
import openPartFinderModal from "@store/Framework/Store/Store/Components/PartFinder/Handlers/OpenPartFinderModal";
import setIsAddingProductToCart from "@store/Framework/Store/Store/Components/PartFinder/Handlers/SetIsAddingProductToCart";
import setProductToAddToModal from "@store/Framework/Store/Store/Components/PartFinder/Handlers/SetProductToAddToModal";
import { PackageModel, PartModel } from "@store/Framework/Types/ApiModels";
import Diagram from "@store/Library/Components/Icons/Diagram";
import Replacement from "@store/Library/Components/Icons/Replacement";
import Warning from "@store/Library/Components/Icons/Warning";
import PartFinderListItemProductLine from "@store/Library/Components/PartFinder/PartFinderListItemProductLine";
import { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { partFinderProps } from "@store/Themes/common/props/partFinder";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useCollectiveProductContext } from "@toolkit/Framework/Components/ProductContext/CollectiveProductContext";
import GetProductContext from "@toolkit/Framework/Components/ProductContext/GetProductContext";
import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: PartFinderListStyles;
    part: PartModel;
    packageModel?: PackageModel;
    replacements?: PartModel[];
    isKit?: boolean;
    hideDrawerActions?: boolean;
    forceLoadInventory?: boolean;
    forceLoadPricing?: boolean;
    onClick?: React.EventHandler<React.MouseEvent>;
    qtyReplacementsChangeHandler?: (
        event: ChangeEvent<HTMLInputElement>,
        replacements: PartModel[] | undefined,
        partId: string | undefined,
    ) => void;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const productState = getProductState(state, ownProps.part.id).value;
    return {
        productToAddToModal: state.store.components.partFinder.productToAddToModal,
        productState,
        state,
        isAddingProductToCart: state.store.components.partFinder.isAddingProductToCart,
    };
};

const mapDispatchToProps = {
    loadProduct,
    openPartFinderDrawer,
    closePartFinderDrawer,
    setProductToAddToModal,
    openPartFinderModal,
    addToCart: makeHandlerChainAwaitable<Parameters<typeof addToCart>[0], CartLineModel>(addToCart),
    setIsAddingProductToCart,
    openMinicartDrawer,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PartFinderListStyles {
    partFinderListItemWrapper?: InjectableCss;
    partFinderListKitItemWrapper?: InjectableCss;
    productQtyFormField?: TextFieldPresentationProps;
    addToCartButton?: ButtonPresentationProps;
    descriptionStyles?: ProductDescriptionStyles;
    partNumbersStyles?: ProductPartNumbersStyles;
    imgWrapper?: InjectableCss;
    partTitle?: InjectableCss;
    criticalPart?: TypographyProps;
    linkPartName?: ClickablePresentationProps;
    partName?: TypographyProps;
    kit?: TypographyProps;
    itemNumber?: TypographyProps;
    partNumber?: TypographyProps;
    partQtyInUnit?: TypographyProps;
    note?: TypographyProps;
    partContainer?: GridContainerProps;
    partImageGridItem?: GridItemProps;
    partDescriptionGridItem?: GridItemProps;
    partDescription?: InjectableCss;
    partAvailability?: InjectableCss;
    partAvailabilityReplacement?: InjectableCss;
    partQtyPriceActionsGridItem?: GridItemProps;
    partQtyPriceActionsGridItemContainer?: GridContainerProps;
    linkWrappingImage?: ClickablePresentationProps;
    img?: ImgProps;
    qtyPriceGridItem?: GridItemProps;
    qtyPrice?: InjectableCss;
    actions?: InjectableCss;
    criticalIcon?: IconPresentationProps;
    viewDiagram?: LinkPresentationProps;
    viewDiagramMobile?: LinkPresentationProps;
    viewReplacement?: LinkPresentationProps;
    productPriceStyles?: ProductPriceStyles;
    obsoleteWrapper?: InjectableCss;
    supersededWrapper?: InjectableCss;
}

const iconLinkStyle = {
    css: css`
        white-space: nowrap;
        justify-content: flex-end;
        color: ${getColor("primary")};
        font-weight: ${x => x.theme.design.typography.weight.bold};
        font-size: ${x => x.theme.design.typography.size.smaller};
        margin-top: ${pxToRem(15)};
    `,
};
const iconPropsStyle = {
    css: css`
        color: ${getColor("primary")};
        margin-right: ${pxToRem(5)};
        width: ${pxToRem(18)};
        height: ${pxToRem(18)};
    `,
};
const partFinderListItemWrapperPropsStyle = {
    css: css`
        position: relative;
        display: flex;
        border-left: ${pxToRem(1)} solid ${getColor("common.border")};
        border-right: ${pxToRem(1)} solid ${getColor("common.border")};
        border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};
        &:first-child {
            border-top: ${pxToRem(1)} solid ${getColor("common.border")};
        }
    `,
};

export const partFinderListStyles: PartFinderListStyles = {
    partFinderListItemWrapper: partFinderListItemWrapperPropsStyle,
    partFinderListKitItemWrapper: mergeProps<PartFinderListStyles["partFinderListKitItemWrapper"]>(
        partFinderListItemWrapperPropsStyle,
        {
            css: css`
                border-left: ${pxToRem(12)} solid ${getColor("common.border")};
            `,
        },
    ),
    itemNumber: {
        css: css`
            padding: 1em;
            position: absolute;
            display: inline-block;
            font-size: ${x => x.theme.design.typography.size.base};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            z-index: 1;
            text-shadow:
                ${pxToRem(1)} ${pxToRem(1)} #fff,
                -${pxToRem(1)} ${pxToRem(1)} #fff,
                ${pxToRem(1)} -${pxToRem(1)} #fff,
                -${pxToRem(1)} -${pxToRem(1)} #fff,
                0 ${pxToRem(1)} #fff,
                -${pxToRem(1)} 0 #fff,
                0 -${pxToRem(1)} #fff,
                ${pxToRem(1)} 0 #fff;
        `,
    },
    productQtyFormField: partFinderProps.productQtyFormField,
    addToCartButton: partFinderProps.addToCartButton,
    imgWrapper: {
        css: css`
            ${StyledImgWrapper} {
                justify-content: center;
            }
        `,
    },
    partContainer: {
        css: css`
            padding: ${pxToRem(15)};
        `,
    },
    partQtyPriceActionsGridItemContainer: {
        css: css`
            align-self: flex-end;
        `,
    },
    partDescription: {
        css: css`
            display: block;
            width: 100%;
        `,
    },
    partNumber: {
        css: css`
            display: inline-block;
            font-size: ${x => x.theme.design.typography.size.smaller};
            color: ${getColor("neutral")};
        `,
    },
    partQtyInUnit: partFinderProps.partQtyInUnit,
    partTitle: {
        css: css`
            display: flex;
        `,
    },
    kit: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
            font-size: ${x => x.theme.design.typography.size.smaller};
            color: ${getColor("secondary")};
            margin-top: 1px;
            margin-right: ${pxToRem(5)};
        `,
    },
    linkPartName: {
        css: css`
            ${linkAltStyles()}
            word-break: break-word;
            padding-right: 1em;
        `,
    },
    partName: {
        css: css`
            display: block;
            font-weight: ${x => x.theme.design.typography.weight.bold};
            span {
                visibility: hidden;

                &:last-of-type {
                    visibility: visible;
                }
                &::before {
                    content: "\\e916";
                    font-family: Icons, sans-serif;
                    font-weight: normal;
                    font-style: normal;
                    font-variant: normal;
                    text-transform: none;
                    line-height: 1;
                    color: ${getColor("secondary")};
                }
            }
        `,
    },
    criticalPart: {
        css: css`
            display: inline-block;
            font-size: ${x => x.theme.design.typography.size.smaller};
            margin-left: ${pxToRem(20)};
        `,
    },
    criticalIcon: {
        src: Warning,
        css: css`
            position: relative;
            top: ${pxToRem(6)};
            margin-right: ${pxToRem(5)};
            width: ${pxToRem(15)};
            height: ${pxToRem(15)};
            color: ${getColor("primary")};
        `,
    },
    partAvailabilityReplacement: {
        css: css`
            align-self: end;
            display: block;
            width: 100%;
        `,
    },
    linkWrappingImage: {
        css: css`
            width: 100%;
        `,
    },
    img: {
        css: css`
            height: auto;
            width: 100%;
        `,
    },
    qtyPrice: {
        css: css`
            height: auto;
            width: 100%;
            white-space: nowrap;
            display: flex;
            align-self: end;
        `,
    },
    viewDiagram: {
        icon: {
            iconProps: {
                src: Diagram,
                css: iconPropsStyle.css,
            },
            position: "left",
        },
        css: css`
            ${iconLinkStyle.css}
            margin-top: 0;
            ${breakpoint("sm", "down")} {
                display: none;
            }
        `,
    },
    viewDiagramMobile: {
        icon: {
            iconProps: {
                src: Diagram,
                css: css`
                    color: ${getColor("primary")};
                    margin-right: ${pxToRem(5)};
                    width: ${pxToRem(18)};
                    height: ${pxToRem(18)};
                    stroke: currentColor;
                    stroke-width: 30px;
                `,
            },
            position: "left",
        },
        typographyProps: {
            css: css`
                visibility: hidden;
                text-indent: -${pxToRem(900)};
            `,
        },
        css: css`
            ${iconLinkStyle.css}
            position: absolute;
            right: 1em;
            top: 1em;
            ${breakpoint("md", "up")} {
                display: none;
            }
        `,
    },
    viewReplacement: {
        icon: {
            iconProps: {
                src: Replacement,
                css: iconPropsStyle.css,
            },
            position: "left",
        },
        css: iconLinkStyle.css,
    },
    partImageGridItem: {
        width: [12, 3, 2, 1, 1],
        css: css`
            position: relative;
            justify-content: center;
        `,
    },
    partDescriptionGridItem: {
        width: [12, 9, 6, 6, 7],
        css: css`
            flex-direction: column;
            justify-content: space-between;
        `,
    },
    partQtyPriceActionsGridItem: {
        width: [12, 12, 4, 5, 4],
        css: css`
            display: flex;
            justify-content: flex-end;
        `,
    },
    qtyPriceGridItem: { width: [12, 6, 12, 6, 6] },
    actions: {
        css: css`
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            ${breakpoint("sm", "down")} {
                justify-content: flex-end;
            }
        `,
    },
    productPriceStyles: {
        quoteMessageWrapper: {
            css: css`
                white-space: normal;
                position: relative;
                padding-right: ${pxToRem(21)};
            `,
        },
        quoteMessage: {
            tooltip: {
                cssOverrides: {
                    tooltipWrapper: css`
                        ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipWrapper}
                        font-weight: ${x => x.theme.design.typography.weight.base};
                        position: absolute;
                        top: 50%;
                        right: 0;
                        margin: 0;
                        transform: translateY(-50%);
                    `,
                },
            },
        },
    },
    obsoleteWrapper: {
        css: css`
            color: ${getColor("warning.main")};
            border: 1px solid ${getColor("warning.main")};
            padding: ${pxToRem(14)};
            margin-top: 1em;
            margin-bottom: 1em;
        `,
    },
    supersededWrapper: {
        css: css`
            margin-top: 1em;
            margin-bottom: 1em;
        `,
    },
};

const PartFinderListItem = ({
    loadProduct,
    productState,
    replacements,
    isKit,
    hideDrawerActions,
    forceLoadInventory,
    forceLoadPricing,
    qtyReplacementsChangeHandler,
    part,
    packageModel,
    setProductToAddToModal,
    openPartFinderModal,
    extendedStyles,
    addToCart,
    setIsAddingProductToCart,
    openMinicartDrawer,
}: Props) => {
    const [styles] = useState(() => mergeToNew(partFinderListStyles, extendedStyles));
    const [orderQty, setOrderQty] = useState<string>("1");
    const toasterContext = useContext(ToasterContext);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const collectiveProductContext = useCollectiveProductContext();
    const contextData = collectiveProductContext.find(x => x.product.id === part?.id);
    const trackAddToCart = ga.use.trackAddToCart();

    useEffect(() => {
        if (part.orderQty) {
            setOrderQty(part.orderQty.toString());
        }
    }, [part]);

    const keyPressHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.which === 13 /* ENTER key */) {
            (event.target as HTMLInputElement).blur();
        }
    };

    const addToCartHandler = React.useCallback(
        async (productContext: ProductContextModel, productQty: string) => {
            setIsAddingProductToCart({ isAddingProduct: true });
            setIsLoading(true);
            const adjustedProductQty = productQty ? (productQty === "0" ? "1" : productQty) : "1";

            if (productState && productContext) {
                const cartline = (await addToCart({
                    productId: productState.id,
                    qtyOrdered: parseInt(adjustedProductQty, 10),
                    unitOfMeasure: productContext.productInfo.unitOfMeasure,
                    onError: () => {
                        setIsAddingProductToCart({ isAddingProduct: false });
                        setIsLoading(false);
                        toasterContext.addToast({
                            body: translate("Cannot add product to cart. Please try again in a few moments."),
                            messageType: "danger",
                        });
                    },
                })) as CartLineModel;
                trackAddToCart({ items: productContext });

                if (cartline) {
                    openMinicartDrawer();
                }

                setIsAddingProductToCart({ isAddingProduct: false });
                setIsLoading(false);
            }
        },
        [productState?.id, packageModel, part],
    );

    const openModalHandler = (productQty: string, productParam: ProductModel, partParam: PartModel) => {
        const adjustedProductQty = productQty ? (productQty === "0" ? "1" : productQty) : "1";
        if (productState) {
            setProductToAddToModal({
                productToAddToModal: {
                    product: productState,
                    qty: adjustedProductQty,
                    qtyInUnit: part.quantity,
                },
            });
            setTimeout(() => {
                openPartFinderModal({ productQty: adjustedProductQty });
            }, 100);
        }
    };
    if (!productState) {
        return (
            <>
                <PartFinderListItemProductLine
                    styles={styles}
                    packageModel={packageModel}
                    part={part}
                    keyPressHandler={keyPressHandler}
                    openModalHandler={openModalHandler}
                    replacements={replacements}
                    hideDrawerActions={isKit}
                    isKit={isKit}
                    qtyReplacementsChangeHandler={qtyReplacementsChangeHandler}
                    setOrderQty={setOrderQty}
                    orderQty={orderQty}
                    isLoading={true}
                    addToCartHandler={addToCartHandler}
                />
            </>
        );
    }

    return (
        <GetProductContext product={productState} loadInventory={forceLoadInventory} loadPrice={forceLoadPricing}>
            <PartFinderListItemProductLine
                contextData={contextData}
                styles={styles}
                packageModel={packageModel}
                part={part}
                keyPressHandler={keyPressHandler}
                openModalHandler={openModalHandler}
                replacements={replacements}
                hideDrawerActions={hideDrawerActions}
                isKit={isKit}
                qtyReplacementsChangeHandler={qtyReplacementsChangeHandler}
                setOrderQty={setOrderQty}
                orderQty={orderQty}
                isLoading={isLoading}
                addToCartHandler={addToCartHandler}
            />
        </GetProductContext>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PartFinderListItem);
